// extracted by mini-css-extract-plugin
module.exports = {"container":"photo_crop_container__1IcOT","wrapper":"photo_crop_wrapper__1qK7x","photo":"photo_crop_photo__13TDm","buttons":"photo_crop_buttons__1CCgo"};